import axios, { AxiosRequestConfig } from "axios";
import { getSelectedEnvironmentId } from "src/storage/appState/environment";
import { filterNullValues } from "src/utils/objectUtils.ts";
import { setupInterceptors } from "./interceptors/setupInterceptors";
import { getSelectedIdentityId } from "src/storage/appState/identitySelection.ts";
import { getFrontendReleaseCode } from "src/config/appConfig.ts";

const ApiClient = setupInterceptors(
	axios.create({
		baseURL: window.location.origin,
		headers: {
			"Content-type": "application/json",
		},
	}),
);

export const makeAxiosRequest = async <ResponseData>(axiosConfig: AxiosRequestConfig = {}) => {
	const response = await ApiClient.request<ResponseData>({
		...axiosConfig,
		headers: {
			...getAavoHeaders(),
			...axiosConfig.headers,
		},
	});

	return response.data;
};

export function getAavoHeaders() {
	return filterNullValues({
		"X-aavo-identity": getSelectedIdentityId(),
		"X-env-association-id": getSelectedEnvironmentId(),
		"X-Client-Time-Zone": Intl.DateTimeFormat().resolvedOptions().timeZone,
		"X-Aavo-Return-To": getCurrentReturnTo(),
		"X-Aavo-Frontend-Release": getFrontendReleaseCode(),
	});
}

function getCurrentReturnTo() {
	return window.location.pathname + window.location.search + window.location.hash;
}
